import React, { useState, useEffect } from "react";
import axios from "axios";

const PreviewProductCategoryAttributeValueModal = ({
  isPreviewModalOpen,
  toggleModal,
  selectedValue,
}) => {
  const [products, setProducts] = useState([]);
  const [attributes, setAttributes] = useState([]);

  // Fetch products and attributes when the modal opens
  useEffect(() => {
    const fetchProductsAndAttributes = async () => {
      try {
        const productResponse = await axios.get("https://api.theonlysale.com/api/product/get");
        setProducts(productResponse.data);

        const attributeResponse = await axios.get("https://api.theonlysale.com/api/category-attributes/get");
        setAttributes(attributeResponse.data);
      } catch (error) {
        console.error("Error fetching products or attributes:", error);
      }
    };

    if (isPreviewModalOpen) {
      fetchProductsAndAttributes();
    }
  }, [isPreviewModalOpen]);

  const productName = products.find(product => product.id === selectedValue?.product_id)?.name || "N/A";
  const attributeName = attributes.find(attribute => attribute.attribute_id === selectedValue?.attribute_id)?.name || "N/A";

  return (
    <>
      {isPreviewModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
          <div className="relative w-full max-w-md p-4 max-h-full">
            <div className="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
              <div className="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Preview Product Category Attribute Value
                </h3>
                <button
                  type="button"
                  onClick={toggleModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="details">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  <strong>Product:</strong> {productName}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  <strong>Attribute:</strong> {attributeName}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  <strong>Value:</strong> {selectedValue?.value || "N/A"}
                </p>
              </div>
              <div className="flex justify-end mt-4">
                <button
                  onClick={toggleModal}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewProductCategoryAttributeValueModal;
